/* eslint-disable func-names */
import { Component } from 'react'
import { Form } from 'antd'
import { __ } from '../../shared/i18n'
import SelectStringWithAutocompletion from '../Input/SelectStringWithAutocompletion'

interface Props {
  handleChange: (value: any) => void
  label?: string
  withoutLabel?: boolean
  rules?: any[]
  name: string
  placeholder?: string
  endpoint: string
  sort: string
  filters?: any
  readonly?: boolean
  withMultipleSelection?: boolean
  maxTagCount?: number
  dependencies?: string[]
  dependenciesParams?: any
  additionalParams?: any
}

export class AdvancedFormStringAutocompleteField extends Component<Props> {
  getLabel = () => {
    const { withoutLabel, label, name } = this.props
    if (withoutLabel) {
      return null
    }
    return label ? __(`fields.labels.${label}`, label) : __(`fields.labels.${name}`)
  }

  handleChange = (value: any) => {
    const { handleChange } = this.props
    if (handleChange) {
      handleChange(value)
    }
  }

  render() {
    const {
      name,
      rules,
      placeholder,
      readonly,
      withMultipleSelection,
      endpoint,
      sort,
      filters,
      maxTagCount,
      dependencies,
      dependenciesParams,
      additionalParams,
    } = this.props
    return (
      <Form.Item name={name.split('.')} rules={rules} label={this.getLabel()} className="stylewhere-form-item">
        <SelectStringWithAutocompletion
          onChange={this.handleChange}
          placeholder={placeholder || __(`fields.placeholders.${name}`)}
          withMultipleSelection={withMultipleSelection}
          readonly={readonly}
          endpoint={endpoint}
          sort={sort}
          filters={filters}
          additionalParams={additionalParams}
          maxTagCount={maxTagCount}
          dependencies={dependencies}
          dependenciesParams={dependenciesParams}
        />
      </Form.Item>
    )
  }
}
